const NA_VALUE = 'N/A';

export const getIsBenchmarkPending = ({ configurations = [] }) => {
  return !!configurations.find(config => config.value === NA_VALUE);
};
